<template>
    <vx-widget
        v-bind="$attrs"
        v-on="$listeners"
        title="Patient Lookup"
        subtitle="Search and find patients"
        overflow-enabled
        h="3"
        category="orders"
        w="18"
        is-resizable
    >
        <!-- <statement-suggest @input="navigate" remove-validation-padding /> -->
        <vx-elastic-suggest
            name="patient name"
            v-model="selectedPatient"
            :showOnFocus="true"
            :search_groups="patient_list"
            placeholder="Search for a Patient"
        >
            <template v-slot:Patients="{ suggestion }">
                <patient-suggest-item :patient="suggestion" />
            </template>
        </vx-elastic-suggest>
    </vx-widget>
</template>

<script>
import PatientSuggestItem from './requests/PatientSuggestItem.vue'
export default {
    name: 'patient-lookup-widget',
    components: {
        PatientSuggestItem
    },
    data() {
        return {
            selectedPatient: {},
            patient_list: {
                Patients: {
                    searchUrl: '/maarima/Patient',
                    idfield: 'id',
                    searchOn: (b) => `${b.firstName.trim()} ${b.lastName.trim()}`,
                    displayText: (b) => this.getDisplayText(b)
                }
            }
        }
    },
    watch: {
        selectedPatient: {
            handler: function (newV) {
                this.goToPatient()
                return this.$emit('input', newV.id)
            },
            deep: true
        }
    },
    computed: {
        // imageName() {
        //     return 'order-finder.png'
        // }
        // patient_list() {
        //     return {
        //         Patients: {
        //             searchUrl: '/maarima/Patient',
        //             idfield: 'id',
        //             searchOn: (b) => `${b.firstName} ${b.lastName}`,
        //             displayText: (b) => this.getDisplayText(b)
        //         }
        //     }
        // }
    },
    methods: {
        // async navigate(statement) {
        //     if (!statement) {
        //         return
        //     }
        //     var type = statement.type.toLowerCase()
        //     var name = `crm-${type}-details`
        //     var params = {}
        //     params[`${type}_id`] = statement.id
        //     this.$router.push({ name, params })
        // }
        getDisplayText(patient) {
            if (patient && patient.id) {
                return `${patient.firstName} ${patient.lastName}`
            }
            return ''
        },
        goToPatient() {
            if (this.selectedPatient && this.selectedPatient.id) {
                this.$router.push(`/patients/${this.selectedPatient.id}`)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.statement-display:hover {
    cursor: pointer;
}
</style>
